module.exports = __webpack_public_path__ + "img/P150T_weapon_96.c5784fb3.png";